import React from 'react';
import { t } from 'i18next';
import Loading from '../components/loading/Loading';


export const toCamelCase = (str) => str.replace(/(?:^\w|[A-Z]|\b\w)/g, (
  letter, index
) => (index === 0 ? letter.toLowerCase() : letter.toUpperCase())).replace(/\s+/g, '');

export const ellipsis = (text, maxLenght = 12) => {
  if (typeof (text) === 'undefined' || text === null || text.length <= maxLenght) return text;
  return `${text.slice(0, maxLenght)}...`;
};

export const formatDesc = (text, maxLength = 100) => {
  if (text.length <= maxLength) return `${text}...`;
  return text;
};

export const numberFormatter = (value, abbrevation = true) => {
  if (value >= 1000 && value < 1000000) {
    return `${+parseFloat(value / 1000).toFixed(2)}${'K'}`;
  }
  if (value >= 1000000 && value < 1000000000) {
    return `${+parseFloat(value / 1000000).toFixed(2)}${abbrevation ? 'M' : ' million'}`;
  }
  if (value >= 1000000000) {
    return `${+parseFloat(value / 1000000000).toFixed(2)}${abbrevation ? 'B' : ' billion'}`;
  }
  return value;
};

export const stringToNumberLocale = (value) => {
  if (Number.isNaN(parseFloat(value))) return value ? t(toCamelCase(value)) : <Loading size={15} />;
  return parseFloat(value).toLocaleString(navigator.language, {
    maximumFractionDigits: value < 10 ? 2 : 0,
    useGrouping: true,
  });
};

export const stringToPercentage = (value) => {
  if (Number.isNaN(parseFloat(value))) return value ? t(toCamelCase(value)) : <Loading size={15} />;

  if (parseFloat(value) >= 1) {
    return `${parseFloat(value).toLocaleString(navigator.language, {
      minimumFractionDigits: 0,
      useGrouping: true,
    })} % `;
  }
  return `${parseFloat(value).toLocaleString(navigator.language, {
    maximumFractionDigits: 2,
    useGrouping: true,
  })} %`;
};
